import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import qs from "qs";
import jurisModal from "@/components/dialog/myfile/fileJurisModal.vue";
import treeMenu from "@/components/treeMenu/index.vue";
import addFile from "@/components/dialog/policyFile/addFilePollicy.vue"; //添加
// import selectScope from "@/components/dialog/jobEvaluation/assessmentManage/selectScope"; //选择考核范围

import { tableList, tHallPolicyFileDelete, tabsList, aclsEdit, aclsSaveEdit, fileDownload } from "@/api/portrayal/policy";
import { mapGetters } from "vuex";
import previewFile from "@/components/common/previewFile.vue"; //文件预览

import { tHallPolicyFileId } from "@/api/portrayal/policy";
export default {
  name: "policyFile",
  components: {
    addFile: addFile,
    treeMenu: treeMenu,
    jurisModal: jurisModal,

    /* selectScope, */
    previewFile: previewFile
  },
  data: function data() {
    return {
      fileType: [".doc", ".docx", ".docm", ".dot", ".dotx", ".dotm", ".odt", ".fodt", ".ott", ".rtf", ".txt", ".html", ".htm", ".mht", ".pdf", ".djvu", ".fb2", ".epub", ".xps", ".xls", ".xlsx", ".xlsm", ".xlt", ".xltx", ".xltm", ".ods", ".fods", ".ots", ".csv", ".pps", ".ppsx", ".ppsm", ".ppt", ".pptx", ".pptm", ".pot", ".potx", ".potm", ".odp", ".fodp", ".otp"].join(","),
      tableLoading: false,
      subState: false,
      tabsData: [],
      tableData: [],
      Page: {
        total: 0,
        current: 1,
        size: 10
      },
      parameter: {
        name: "",
        orderBy: "",
        direction: "DESC",
        tabsId: ""
      },
      addData: {
        state: false,
        selectData: [],
        tabsId: "" // path: 'policyFiles'

      },
      editData: {
        state: false,
        data: null
      },
      jurisData: {
        state: false,
        id: null
      },
      selectScopeData: {
        state: false,
        type: "",
        key: Date.parse(new Date()),
        defaultSelected: [],
        selectedUserListArr: [],
        depts: [],
        mans: [],
        fileId: "",
        title: "教师权限"
      },
      // juris
      editJuris: {
        scope: {
          deptIds: [],
          userIds: []
        }
      },
      typeOptions: []
    };
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread({}, mapGetters(["permissions", "chooseDept"])), {}, {
    deptPower: function deptPower() {
      // return this.permissions.sys_edit_file;
      return true; // 权限问题暂时写死
    },
    deptData: function deptData() {
      // const deptData = ;
      return JSON.parse(JSON.stringify(this.chooseDept));
    }
  }),
  mounted: function mounted() {
    this.typeOption();
    this.getList();
  },
  methods: {
    viewFile: function viewFile(row) {
      var routeData = this.$router.resolve({
        name: "/fileDetail",
        query: {
          id: row.id,
          fileId: row.fileId || ""
        }
      });
      window.open(routeData.href);
    },
    typeOption: function typeOption() {
      var _this = this;

      tabsList("/admin/dict/type/policy_type").then(function (res) {
        if (res.data.code == 0) {
          res.data.data.forEach(function (e) {
            var o = {
              id: Number(e.value),
              name: e.label
            };

            _this.typeOptions.push(o);
          });
        }
      });
    },
    preview: function preview(row) {
      row.previewPath = "policyFiles";
      this.$store.commit("setPreviewFileData", {
        data: row,
        state: true
      }); // this.$router.push("/previewFile");
    },
    closePreviewFile: function closePreviewFile() {
      this.previewFileData.state = false;
    },
    filterDeptRowById: function filterDeptRowById(source, id) {
      var result = "";

      if (source && source.length > 0) {
        var filterFun = function filterFun(target) {
          target.forEach(function (item) {
            if (item.id == id) {
              result = item;
            } else {
              if (item.children && item.children.length > 0) {
                filterFun(item.children);
              }
            }
          });
        };

        filterFun(source);
      }

      return result;
    },
    filterDeptTree: function filterDeptTree(source, id) {
      var result = "";

      if (source && source.length > 0) {
        var filterFun = function filterFun(target) {
          target.forEach(function (item) {
            if (item.id == id && item.children.length < 1) {
              result = item;
            }

            if (item.children && item.children.length > 0) {
              filterFun(item.children);
            }
          });
        };

        filterFun(source);
      }

      return result;
    },
    closeSelectScope: function closeSelectScope(data) {
      var _this2 = this;

      if (data) {
        var params = {
          deptIds: [],
          userIds: []
        };
        params.deptIds = data.depts.map(function (item) {
          return item.id;
        });
        data.mans.forEach(function (item) {
          if (item.mans.length > 0) {
            item.mans.forEach(function (item, index) {
              params.userIds.push(item.userId);
            });
          }
        });
        var queryObj = {
          deptIds: params.deptIds,
          userIds: params.userIds
        };
        aclsSaveEdit(queryObj, this.selectScopeData.fileId).then(function (res) {
          _this2.subDisabled = false;

          if (res.data.code == 0) {
            _this2.$message({
              message: "权限修改成功",
              type: "success"
            });

            _this2.selectScopeData.state = false;

            _this2.getList();
          } else {
            _this2.$message.success(res.data.msg);
          }
        });
      }
    },
    changeJuris: function changeJuris() {
      var deptArray = this.editJuris.scope.deptIds.map(function (item) {
        return item.id;
      });
      this.selectScopeData.depts = JSON.parse(JSON.stringify(deptArray));
      this.selectScopeData.mans = JSON.parse(JSON.stringify(this.editJuris.scope.userIds));
      this.selectScopeData.state = true;
    },
    closeJuris: function closeJuris() {
      this.jurisData.state = false;
    },
    lookOver: function lookOver(row) {
      this.jurisData.state = true;
      this.$refs.jurisModal.getTreeData(row.fileId);
    },
    searchusers: function searchusers() {
      this.getList(1);
    },
    //清空
    reservise: function reservise() {
      this.parameter.name = "";
      this.getList();
    },
    //排序方法
    tableSortChange: function tableSortChange(column) {
      if (column.prop == "fileName") {
        this.parameter.orderBy = "1";

        if (column.order === "descending") {
          this.parameter.direction = "DESC";
        } else {
          this.parameter.direction = "ASC";
        }
      }

      if (column.prop == "createTime") {
        this.parameter.orderBy = "2";

        if (column.order === "descending") {
          this.parameter.direction = "DESC";
        } else {
          this.parameter.direction = "ASC";
        }
      }

      this.getList();
    },
    nodeId: function nodeId(tree) {
      // this.policyType = int
      this.fillType = 0;
      this.nameIndexValue = 0;
      this.sortType = 0;

      if (tree.id == 0) {
        this.parameter.tabsId = "";
      } else {
        this.parameter.tabsId = tree.id;
      }

      this.getList(1);
    },
    closeAddFiles: function closeAddFiles(val) {
      this.addData.state = val;
      this.getList(1);
    },
    addDataClick: function addDataClick() {
      this.$refs.addfile.dialogShow("add");
    },
    // 下载
    download: function download(row) {
      var _this3 = this;

      // this.subState = true;
      if (row.downUrl) {
        var url = row.downUrl;

        if (url.indexOf("http") < 0) {
          url = "http://" + url;
        } // location.href = url


        window.open(url);
        return;
      }

      this.$DownLoad("/admin/file/download/" + row.fileId, null, function (res) {
        if (res.status == 200) {// this.$message.success("开始下载");
        } else {
          _this3.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this3.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    },
    downloadFn: function downloadFn(url, name) {
      var x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = "blob";

      x.onload = function (e) {
        var url = window.URL.createObjectURL(x.response);
        var a = document.createElement("a");
        a.href = url;
        a.download = name;
        a.click();
      };

      x.send();
    },
    closeEdit: function closeEdit() {
      this.editData.state = false;
      this.getList();
    },
    editDataClick: function editDataClick(row) {
      var _this4 = this;

      this.tableLoading = true;
      tHallPolicyFileId(row.id).then(function (_ref) {
        var data = _ref.data;
        _this4.tableLoading = false;

        if (data.code == 0) {
          _this4.$refs.addfile.dialogShow("edit", data.data || {});
        } else {
          _this4.$message.error(data.msg || "获取校内公文失败！");
        }
      }).catch(function (err) {
        _this4.tableLoading = false;

        _this4.$message.error("服务器异常!");
      });
    },
    // 删除
    handleDel: function handleDel(row) {
      var _this5 = this;

      this.$confirm("是否确认删除:" + row.title, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        tHallPolicyFileDelete(row.id).then(function (res) {
          if (res.data.code === 0) {
            _this5.$message.success("删除成功");

            _this5.getList(1);
          } else {
            _this5.$alert("删除出错,请稍后重试", "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          }
        });
      }).catch(function () {});
    },
    getList: function getList(page) {
      var _this6 = this;

      this.tableLoading = true;
      this.Page.current = page ? page : this.Page.current;
      var obj = {
        current: this.Page.current,
        size: this.Page.size,

        /*  viewAll: true,*/
        type: this.parameter.tabsId,
        keywords: this.parameter.name // pinyinIndex: '',
        // orderBy: this.parameter.orderBy,
        // direction: this.parameter.direction

      };
      tableList(obj).then(function (res) {
        if (res.data.code == 0) {
          _this6.tableData = res.data.data.records;
          _this6.Page.total = res.data.data.total;
          _this6.tableLoading = false;
        } else {
          _this6.$message.error(res.data.msg);
        }
      }).finally(function () {
        _this6.tableLoading = false;
      });
    },
    // 分页
    handleSizeChangeUser: function handleSizeChangeUser(val) {
      this.Page.size = val;
      this.getList(1);
    },
    handleCurrentChangeUser: function handleCurrentChangeUser(val) {
      this.Page.current = val;
      this.getList();
    }
  }
};